<template>
  <div class="flex items-center">
    <p>{{ params.value.name || params.value.name_en }}</p>
  </div>
</template>

<script>

  export default {
    name: "CellRendererUserName",
  };
</script>
